import React from 'react';
import { Redirect } from 'react-router';
import {domain,redirectToMyGame,baseUrl} from '../common/config.js';
import {apiService} from '../common/apiCallService';
import AuthenticateUser from './AuthenticateUser.js'
import LinearProgress from 'material-ui/LinearProgress';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
const queryString = require('query-string');

export default class RedirectToMyGameFrmClient extends React.Component {
  constructor(props){
    super(props);
    this.state={
      partyPokerUserDetails: {},
      location:'/',
      msg:"No valid partner",
      open: false,
    }
    if(Object.keys(props).length > 0){
      if(queryString.parse(props.location.search).page)
        this.validateUser()
    }
  }

 
  validateUser = () =>{
    if (queryString.parse(this.props.location.search).partner == 'PartyPoker') {
        this.state.partyPokerUserDetails.buisness_Name = 'MyGame'     
        this.state.partyPokerUserDetails.selectedRole = ['PLAYER']
        this.forceUpdate()
        if(this.state.partyPokerUserDetails){
          apiService(baseUrl + '/appUser/partyPokerUserLoginHC', {
            "resultCode":0,"result":"SUCCESS","firstName":"PPPARTY322FN","lastName":"PPPARTY322LN","accountId":"116186876","accountName":"pp_party322","alias":"GenzoUmon"
          }, (data) => {
            localStorage.setItem("username", data.username)
            localStorage.setItem("alias", data.alias)
            data.accountName && localStorage.setItem("accountName", data.accountName)
            localStorage.setItem("token", data.token)
            localStorage.setItem("activityTrack", [])
            localStorage.setItem("name", data.first_name + " " + data.last_name)
            localStorage.setItem("userRole", JSON.stringify(data.user_role))
            this.isAuthenticated =  true
            if(queryString.parse(this.props.location.search).page )
              this.props.history.push('/course')
          }, (data) => {
            this.isAuthenticated =  false
            this.setState({msg: "Something went wrong...Please try again"})
            this.setState({open: true})
          })
        }
    }
    else{
        this.state.open = true
        this.forceUpdate()
    }
  }

  handleOpen = () => {
    this.setState({open: true});
  }
 
  handleClose = () => {
    this.setState({
      loginRedirect:true,
      location:'/',
      open: false
    })
  }
  
  render() {
    const actions = [<FlatButton label="Ok" primary={true} keyboardFocused={true} onClick={this.handleClose}/>]
    return(
      <div className="app-content-loading" style={{backgroundColor: '#2D2C34'}}>
        <center>
          <img id="loadingImg" src={require('../img/login-logo.png')} style={{width:'30%',marginTop:'10%'}} alt="Loading..." />
          <LinearProgress mode="indeterminate" color= '#DE460F'  style={{width:'40%'}} />
        </center>
        <Dialog actions={actions} modal={false} open={this.state.open}   onRequestClose={this.handleClose}>{this.state.msg} </Dialog>
        {this.state.loginRedirect && (<Redirect to={this.state.location}/>)}
      </div>
    )
  }
}




/** WEBPACK FOOTER **
 ** ./src/components/RedirectToMyGameFrmClient.js
 **/